import {
  QualificationApprovalDetails,
  QualificationApprovalState,
  QualificationApprovalType,
  ProcessingState,
} from '@sdir/httpclient/lib/clients/aps/course';

/**
 * QualificationApprovalState is intended to be removed in future API versions
 * @param applicationUid application UID
 * @param attachmentUid  attachment UID
 * @returns QualificationApprovalState referencing application and single attachment
 */
export const createQualificationApprovalDetails = (
  applicationUid: string,
  attachmentUid: string
): QualificationApprovalDetails => ({
  applicationReference: applicationUid,
  attachementReference: attachmentUid,
  type: QualificationApprovalType.Manual,
});

export const createQualificationApprovalState = (): QualificationApprovalState => ({
  processingState: ProcessingState.Unprocessed,
});
